import React from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { MenuLink } from "../../../Button";
import { MenuDivider } from "../../../Divider";
import { UserIcon, SettingsIcon } from "../../../../../components/atoms/icons";
import { SubscriptionsIcon } from "../../../../../MVVM/Components/Icons";
import { useIsDesktopApp } from "../../../../Hooks/useIsDesktopApp";
import { HiSupport } from "react-icons/hi";
import { LanguagesDropdown } from "../../../../../components/organisms/nav/languagesDropDown";
import { useTranslation } from "react-i18next";

function GamesDropdown(props: any) {
  return (
    <DropdownContainer className={props.className}>
      <MenuLink to="/valorantclips">Valorant</MenuLink>
      <MenuLink to="/rainbow6clips">Rainbow 6</MenuLink>
    </DropdownContainer>
  );
}

export function NavListDropdown({ allstarUser, logout, className }: any) {
  const { t } = useTranslation("translation", {
    keyPrefix: "nav.listDropdown",
  });

  const isDesktopView = useIsDesktopApp();

  if (isDesktopView.isDesktop) {
    return <></>;
  }

  return (
    <DropdownContainer className={className}>
      <MenuLink
        isActive={(location: any) => {
          if (!location) {
            return false;
          }
          const urlParams = new URLSearchParams(window.location.search);
          const viewingProfile = urlParams.get("user");
          return viewingProfile === allstarUser.user._id;
        }}
        to={"/profile"}
      >
        <UserIcon size={22} mr={4} />
        {t("profile")}
      </MenuLink>
      <MenuLink to="/accountsettings">
        <SettingsIcon size={22} mr={4} />
        {t("accountSettings")}
      </MenuLink>
      <MenuLink to="/support">
        <Box mr={4}>
          {" "}
          <HiSupport size={22} />
        </Box>
        {t("support")}
      </MenuLink>
      <MenuDivider />
      <MenuLink to="/upgrade">
        <Box mr={4}>
          {" "}
          <SubscriptionsIcon size={22} />
        </Box>
        {t("upgrade")}
      </MenuLink>
      <MenuDivider />
      <Languages
        mx={3}
        variant="link.railFooter"
        alignContent={"center"}
        justifyContent="center"
      >
        <LanguagesDropdown />
      </Languages>
      <MenuDivider />
      <MenuLink
        href="#"
        onClick={() => {
          logout("User Initiated - Top Right Dropdown");
        }}
      >
        {t("signOut")}
      </MenuLink>
    </DropdownContainer>
  );
}

const Languages = styled(Box)`
  z-index: 2000;
  &:hover {
    color: ${(props) => props.theme.colors.envy};
  }
`;

const DropdownContainer = styled(Flex)`
  font-size: ${(props) => props.theme.text.body.fontSize};
  white-space: nowrap;
  flex-direction: column;
`;
